import React, { Component } from 'react';
import Hls from 'hls.js';

function djb2_hash(s) {
  let h = 5381;

  for (let i = 0; i < s.length; i++) {
      h = (h * 33 + s.charCodeAt(i)) >>> 0;
  }

  return h;
}

export default class HLSSource extends Component {
  constructor(props, context) {
    super(props, context);
    this.hls = new Hls({
      xhrSetup: (xhr, url) => {
        const oUrl = JSON.parse(JSON.stringify({a:url}));
        let val1 = /^http:\/\/stream\.sharifin\.com(.*)(?=\?)/g.exec(url);
        let val2 = /^http:\/\/stream\.sharifin\.com(.*)(?=$)/g.exec(url);
        if (process.env.REACT_APP_SSL_ON) {
          val1 = /^https:\/\/stream\.sharifin\.com(.*)(?=\?)/g.exec(url);
          val2 = /^https:\/\/stream\.sharifin\.com(.*)(?=$)/g.exec(url);
        }
        const path = (val1 || val2)[1];
        if (!path) {
          throw new Error(`can not detect path from this url '${url}'`);
        }
        xhr.setRequestHeader('Secret-Key', djb2_hash(path));
        url = oUrl.a;
      },
      autoStartLoad: true,
      maxBufferHole:2.5,
      backBufferLength:0,
      maxBufferSize:120000000
    });
  }

  componentDidUpdate(preProps) {
    if (preProps.level !== this.props.level) {
      this.setLevel(this.props.level);
    }
  }

  getLevels(levels) {
    if (levels) {
      return levels.map((level, index) => {
        let isCurrent = false;
        if (this.hls.currentLevel === -1 && index === 0) {
          isCurrent = true;
        }
        if (this.hls.currentLevel === index) {
          isCurrent = true;
        }
        return {
          value: index,
          label: level.height >= 720 ? 'HD' : `${level.height}px` ,
          isCurrent,
        }
      });
    } else {
      return []
    }
  }

  setLevel(levelId) {
    this.hls.currentLevel = levelId;
  }

  componentDidMount() {
    const { src, video } = this.props;
    if (Hls.isSupported()) {
      this.hls.loadSource(src);
      this.hls.attachMedia(video);
      this.hls.on(Hls.Events.MANIFEST_PARSED, (e, data) => {
        this.props.onGetLevels(this.getLevels(data.levels));
        this.hls.startLoad(0);
      });
      this.hls.on(Hls.Events.ERROR, (event, data) => {
        console.error('hls');
        console.log(data);
      });
    }
  }


  componentWillUnmount() {
    if (this.hls) {
      this.hls.destroy();
    }
  }

  render() {
    return (
      <source
        src={this.props.src}
        type={this.props.type || 'application/x-mpegURL'}
      />
    );
  }
}
